<template>
<div>
	<ul class="title-nav">
		<li v-on:click="handleBack()">
			<div class="back-btn">
				<i class="material-icons md-18">keyboard_arrow_left</i>
			</div> 
			
			<div class="title-label"><i class="material-icons md-18">business_center</i> PERMITS ({{parcel.permits.length}})</div>
		</li>
	</ul>
	<div v-if="parcel.permits.length === 0" class="section-title text-center">
		No permits for this parcel
	</div>
	<div v-for="(permit, index) in parcel.permits" class="section">
		<div class="section-title">
			{{permit.typeRaw}}
		</div>
		<div class="section-body">
			<div v-if="permit.description !== null" class="category">
				<div class="category-title">DESCRIPTION</div>
				<div v-if="!parcel.unlocked" v-on:click="unlock" class="lock-block mt-2 mb-2">
					<div class="lock-icon-box">
						<i class="material-icons md-36">lock</i>
					</div>
					<div class="lock-text">
						<h5 class="mb-0 text-white">Unlock to view permit description</h5>
						<h5 class="mb-0 font-weight-light text-light">${{plans.parcelUnlock.price}} to unlock all info for this parcel</h5>
					</div>
				</div>
				<div v-else class="property-row">
					<div class="text-description property-locked">{{permit.description}}</div>
				</div>
			</div>

			<div v-if="permit.appliedDate !== null || permit.issuedDate !== null ||
				permit.completedDate !== null" class="category">
				<div class="category-title">DETAILS</div>
				<div v-if="permit.appliedDate !== null" class="property-row">
					<label>Applied</label>
					<div class="property-value-right property-locked">
						{{permit.appliedDate | longDate}}
					</div>
				</div>
				<div v-if="permit.issuedDate !== null" class="property-row">
					<label>Issued</label>
					<div class="property-value-right property-locked">
						{{permit.issuedDate | longDate}}
					</div>
				</div>
				<div v-if="permit.completedDate !== null" class="property-row">
					<label>Completed</label>
					<div class="property-value-right property-locked">
						{{permit.completedDate | longDate}}
					</div>
				</div>
			</div>

			<div v-if="permit.jurisdictionPermitId" class="category">
				<div class="category-title">REFERENCES</div>
				<div class="property-row">
					<label>Source</label>
					<div class="property-value-right">
						<a :href="jurisdictionPermitURL(permit.jurisdictionPermitId)" v-if="permit && permit.link" target="_blank" class="property-locked">
							#{{permit.jurisdictionPermitId}}
							<i class="material-icons md-12">open_in_new</i>
						</a>
						<span v-else>#{{permit.jurisdictionPermitId}}</span>
					</div>
				</div>
			</div>

			<div class="over-sign-in d-flex" v-if="unlocked === false" v-on:click="unlock">
				<div class="over-sign-in-box align-self-center text-white hover-dk">
					<div class="text-center">
						<i class="material-icons text-light md-36">lock</i>
					</div>
					<div class="text-center">
						Unlock to view
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>

export default {
	props: {
		addressId: Number,
		handleBack: {
			type:Function,
			required:true
		},
		parcel:{
			type:Object,
			required:true,
		},
	},
	methods:{
		unlock: function(){
			this.$router.push({
				name: 'unlock-parcel', 
				params:{
					parcelId: this.parcel.id
				},
				query:{
					addressId: this.addressId
				}
			});
		},
		jurisdictionPermitURL: function(permitId){
			//	TODO: make this dynamic for all jurisdictions
			return 'https://opendsd.sandiego.gov/Web/Approvals/Details/'+permitId;
		}
	},
	computed:{
		token: function(){
			return this.$store.state.agent.token;
		},
		plans:function(){
			return this.$store.state.plan.plans;
		},
		unlocked:function(){
			return true;
		}
	}
}

</script>

<style>
	.bg-gray{background-color:#FAFAFA;}
	.font-10{font-size:10px;}
	.censor-block{height:18px;width:100px;background-color:#455963;}
	.text-blur{color:transparent;text-shadow:0px 0px 10px #999;}
	.over-sign-in{
		position:absolute;top:0;left:0;right:0;bottom:0;background-color:rgba(55,71,79,0.2);}
	.over-sign-in-box{padding:12px 0;width:120px;margin:0 auto;
		text-align:center;color:#fff;}
</style>


// WEBPACK FOOTER //
// src/components/parcel/parcel-permits.vue